import { ReactNode } from "react";

import { Box, Heading, Stack, Text } from "@seneca/senekit";

import { ErrorMessage as ErrorMessageType } from "services/firebase/auth/errorTranslator";

import { ErrorMessage } from "features/sign-up/common-routes/components/form";

export type ModalProps = {
  errorMessage?: ErrorMessageType;
  headerMessage?: string;
  defaultHeaderMessage: string;
  subHeading?: string;
  children: ReactNode;
};

export function ModalWrapper({
  children,
  errorMessage,
  headerMessage,
  defaultHeaderMessage,
  subHeading
}: ModalProps) {
  const showSubheading = !!subHeading && !errorMessage && !headerMessage;

  return (
    <Box dataTest="SignUpFormWrapper">
      <Stack align="center" space="xxlarge">
        <Stack align="center">
          <Heading level="3" align="center">
            {headerMessage ?? defaultHeaderMessage}
          </Heading>
          {errorMessage && (
            <Box marginTop="xlarge" width="100%">
              <ErrorMessage errorMessage={errorMessage} />
            </Box>
          )}
          {showSubheading && (
            <Text size="small" weight="bold">
              {subHeading}
            </Text>
          )}
        </Stack>
        {children}
      </Stack>
    </Box>
  );
}
